import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';

@Injectable()
export class MyreTranslateParser extends TranslateDefaultParser {
  public override interpolateFunction(
    expr: (options: { bindings: any }) => string,
    params: any,
  ): any {
    return expr({
      bindings: params,
    });
  }
}
